
import { showToast } from "vant";
export const copyText = (vname, dcode) => {
    const textarea = document.createElement('textarea');
    textarea.value = `视频: ${vname}\n优惠码: ${dcode}\n该优惠码只能使用一次,请勿多次分享`
    document.body.appendChild(textarea);
    textarea.select();

    try {
        const success = document.execCommand('copy');
        if (success) {
            showToast('优惠码已复制到剪切板,直接粘贴即可')
        } else {
            showToast('复制失败,请前往订单中心复制')
            throw new Error('复制失败');
        }
    } catch (err) {
        console.error('复制失败:', err);
        showToast('复制失败,请前往订单中心复制')
    } finally {
        document.body.removeChild(textarea);
    }
};